<template>
  <div class="control">
    <div class="field has-addons">
      <div class="control is-expanded">
        <input class="input" type="text" disabled :value="readonlyValue" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  readonlyValue: {
    type: String,
    required: true,
  },
});
</script>
